var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-separator"},[_c('div',{staticClass:"the-divider"},[_c('div',{staticClass:"line"}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"line"})]),_vm._t("default"),_c('div',{staticClass:"the-bottom-divider"},[_vm._v(" ")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bfcb2c7c","hasScoped":true,"buble":{"transforms":{}}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layout/SectionSeparator.vue
// module id = 710
// module chunks = 0